import { CalendarSelectItemType } from './CalendarSelectFormField.types';

export const formatCalendarsToSelectOptions = (calendars?: CalendarSelectItemType[]): { value: string; label: string }[] =>
  (calendars || []).map(({ calendarId, calendarName }) => ({
    value: calendarId,
    label: calendarName,
  }))
